import React, { memo } from 'react'

const TabLabelWithCount = ({ label, count }) => {
  return (
    <span className="tab_label_container">
      {label} <span className="tab_label_count">{count}</span>
    </span>
  )
}

export default memo(TabLabelWithCount)
